import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PollList',
  props: {
    list: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  list: { id: number | string; [key: string]: any }[];
  size: number;
};


const viewList = ref<any[]>([]);
const pollRefs = ref<HTMLDivElement | null>(null);
const topHeight = ref(0);
function getViewItems() {
  if (!pollRefs.value) {
    return;
  }
  const clientHeight = pollRefs.value.clientHeight; //实际高度
  const scrollTop = pollRefs.value.scrollTop; //滚动距离
  const itemCount = Math.floor(clientHeight / props.size) + 1; //数量
  const topLength = Math.floor(scrollTop / props.size);
  topHeight.value = topLength * props.size;
  const new_view_list = [] as any;
  for (let i = topLength; i <= topLength + itemCount; i++) {
    new_view_list.push(props.list?.[i]);
  }
  viewList.value = new_view_list;
}
onMounted(() => {
  getViewItems();
});

return { __sfc: true,props, viewList, pollRefs, topHeight, getViewItems }
}

})